import React from 'react';
import { SvgIcon } from '@mui/material';

const ClearTextField = ({ ...props }) => (
    <SvgIcon
        {...props}
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.42856 23.9999C3.42856 12.6393 12.6394 3.42847 24 3.42847C35.3606 3.42847 44.5714 12.6393 44.5714 23.9999C44.5714 35.3605 35.3606 44.5713 24 44.5713C12.6394 44.5713 3.42856 35.3605 3.42856 23.9999ZM32.0691 32.069C32.7394 31.3988 32.7394 30.3153 32.0691 29.645L26.424 23.9999L32.0691 18.3548C32.7394 17.6845 32.7394 16.601 32.0691 15.9308C31.3988 15.2605 30.3154 15.2605 29.6451 15.9308L24 21.5759L18.3548 15.9308C17.6846 15.2605 16.6011 15.2605 15.9308 15.9308C15.2606 16.601 15.2606 17.6845 15.9308 18.3548L21.576 23.9999L15.9308 29.645C15.2606 30.3153 15.2606 31.3988 15.9308 32.069C16.2651 32.4033 16.704 32.5713 17.1428 32.5713C17.5817 32.5713 18.0206 32.4033 18.3548 32.069L24 26.4239L29.6451 32.069C29.9794 32.4033 30.4183 32.5713 30.8571 32.5713C31.296 32.5713 31.7348 32.4033 32.0691 32.069Z"
            fill="#111111"
            fillOpacity="0.3"
        />
    </SvgIcon>
);

export default ClearTextField;
